import { callApi } from './api'

export function unsetResultsdone(sitekey, contestroundId) {
  return callApi('PUT', `/contestround/${contestroundId}/unsetresultsdone`, sitekey)
}


// WEBPACK FOOTER //
// ./src/services/contestround.api.js